<template>
  <!-- max-w-7xl w-full -->
  <div class="max-w-full mx-auto rounded-[10px] bg-white">
    <RouterView></RouterView>
  </div>
</template>
